const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="demo-u-rounded-sizes">
  `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(new Map([[0, `u-rounded`], [1, `u-rounded-full`], [2, `u-rounded-none`]]));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`class`] = __value__;
                    this.echo(`    `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, context.get(`class`)]]), true, false, 3));
                    this.echo(`  `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('class');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`</div>
`);
            }

            getTemplateName() {
                return `0d38ff9b80d86c2d7c95ebcdde878ae2a445df8bb1ec2ac8279d310133c8690f`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `0d38ff9b80d86c2d7c95ebcdde878ae2a445df8bb1ec2ac8279d310133c8690f`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '0d38ff9b80d86c2d7c95ebcdde878ae2a445df8bb1ec2ac8279d310133c8690f');

let template = env.loadTemplate('0d38ff9b80d86c2d7c95ebcdde878ae2a445df8bb1ec2ac8279d310133c8690f');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/rounded/demo/sizes.twig", args: context }
     );
     return rendered;;
};